<template>
  <router-view />
</template>

<style>
#app {
  font-family: 'Noto Sans SC'!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

td p {
  margin: 0px ;
  color:#2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

th {
  text-align: center;
  vertical-align: middle;
}

td {
  text-align: center;
  vertical-align: middle !important;
  border: 1px solid #e3e6f0 !important;
    color:#2c3e50;
}

p,
span,
pre,  
h1.h2,
h3,
h4,
h5,
h6 {
  text-align: left;
}

.card {
  margin: 20px 0px;
}


.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: transparent !important;
  opacity: 0.8 !important;
}

#dataTable {
  overflow-y: hidden;
  overflow-x: hidden;
}

.table-responsive {
  overflow-y: hidden;
  overflow-x: hidden !important;
}

card-body {
  overflow-y: hidden;
  overflow-x: hidden;
}

.tox-tinymce-aux {
  z-index: 3000 !important;
}
mark{
  padding: 0 !important;
  background-color: yellow !important;
}


</style>
